import { useMemo } from "react";
import { useIntl } from "react-intl";
import DataTableMessages from "../intl/DataTableMessages";

const { of, to } = DataTableMessages;

const useCurrentPageReportTemplate = () => {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    const ofTxt = formatMessage(of);
    const toTxt = formatMessage(to);

    return `{first} ${toTxt} {last} ${ofTxt} {totalRecords}`;
  }, [formatMessage]);
};

export default useCurrentPageReportTemplate;
